import { render } from "./DataViewerPreviewSentTemplate.vue?vue&type=template&id=65e2e77b"
import script from "./DataViewerPreviewSentTemplate.vue?vue&type=script&lang=ts"
export * from "./DataViewerPreviewSentTemplate.vue?vue&type=script&lang=ts"
script.render = render

export default script